/**
 * Services
 */
export * from './services/service-locator';
export * from './services/renderer-factory';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-richtexteditor/src/rich-text-editor/services.js
// module id = ./node_modules/@syncfusion/ej2-richtexteditor/src/rich-text-editor/services.js
// module chunks = vendor